//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
import Draggable from 'vuedraggable';
import { deepClone } from '@/utils/util';
export default {
  name: 'tab-customClass-editor',
  componentName: 'PropertyEditor',
  mixins: [i18n],
  components: {
    Draggable: Draggable
  },
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      cssClassList: []
    };
  },
  created: function created() {
    var _this = this;
    this.cssClassList = deepClone(this.designer.getCssClassList());
    //监听表单css代码改动事件并重新加载！
    this.designer.handleEvent('form-css-updated', function (cssClassList) {
      _this.cssClassList = cssClassList;
    });
  },
  methods: {
    onTabPaneActiveChange: function onTabPaneActiveChange(evt, tpItem) {
      //TODO: !!!
    },
    addTabPane: function addTabPane(curTabs) {
      this.designer.addTabPaneOfTabs(curTabs);
      this.designer.emitHistoryChange();
    },
    deleteTabPane: function deleteTabPane(curTabs, tpIdx) {
      if (curTabs.tabs.length === 1) {
        this.$message.info(this.i18nt('designer.hint.lastPaneCannotBeDeleted'));
        return;
      }
      this.designer.deleteTabPaneOfTabs(curTabs, tpIdx);
      this.designer.emitHistoryChange();
    }
  }
};